<template>
    <div class="large">
        <div class="layout">
            <main id="view-pay">
                <div class="brand">
                    <svg-logo height="100" />
                </div>
                <template v-if="!loading">
                    <template v-if="!error">
                        <h4>Renew your subscription at PDFShift</h4>
                        <p>You'll be redirected to our partner, Stripe, in 5 seconds, in order to finalize your payment.</p>

                        <a :href="invoice_url" class="btn">Redirect me now</a>
                    </template>
                    <template v-else>
                        <div class="alert alert-error">
                            <p>We couldn't find the invoice you requested. Maybe it has been deleted?</p>
                            <p><router-link :to="{ name: 'dashboard' }" class="secondary">Redirect to the home page</router-link></p>
                        </div>
                    </template>
                </template>
            </main>
        </div>
    </div>
</template>

<script>
import SvgLogo from '@/assets/images/logo.svg'

export default {
    components: { SvgLogo },
    data () {
        return {
            loading: true,
            invoice_url: null,
            error: false
        }
    },
    async created () {
        this.loading = true
        try {
            const response = await this.$http.get('invoices/' + this.$route.params.invoiceId)
            this.invoice_url = response.body.invoice_url
            setTimeout(() => {
                window.location.href = this.invoice_url
            }, 5000)
        } catch (e) {
            this.error = true
        } finally {
            this.loading = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../public/css/vars';

#view-pay {
    text-align: center;
    width: 80rem;
    margin: 0 auto;

    svg { margin-bottom: 2rem; }

    h4 {
        margin-top: 2rem;
        margin-bottom: .5rem;
    }

    .btn {
        margin-top: 5rem;
        padding: 2rem 6rem;
    }
}
</style>
